<!-- VIAJE COMERCIAL -->
<div class="boxWhite md" [ngClass]="{'d-none': !isTripTypeSelected(tripTypes.COMERCIAL)}">

  <h4>NUEVO SERVICIO COMERCIAL</h4>

  <button class="btn btnClose" (click)="cerrarModal()">
    <img src="assets/img/icoClose.svg">
  </button>

  <div class="contModal">
    <div class="row">
      <div class="col-md-6">
        <div class="mb-4">
          <select class="form-select" [(ngModel)]="selectedTripType" (change)="onTripTypeChange(selectedTripType)">
            <option *ngIf="tienePermisoCrearViajeComercial()" [value]="tripTypes.COMERCIAL">SERVICIO COMERCIAL</option>
            <option *ngIf="tienePermisoCrearViajeNoComercial()" [value]="tripTypes.NO_COMERCIAL">SERVICIO NO COMERCIAL</option>
            <option *ngIf="tienePermisoCrearViajeEspecial()" [value]="tripTypes.ESPECIAL">SERVICIO ESPECIAL</option>
          </select>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="mb-4">
          <ng-select placeholder="BUSCAR SERVICIO..." [multiple]="false" [items]="listaServicios" bindLabel="nombre"
            [(ngModel)]="servicioSeleccionado">
            <ng-template ng-label-tmp let-item="item">
              <span>{{ item.nombre }} ({{item.sentido}}) [{{item.sucursalOrigenNombre}},
                {{item.sucursalDestinoNombre}}]</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
              <span>{{ item.nombre }} ({{item.sentido}}) [{{item.sucursalOrigenNombre}},
                {{item.sucursalDestinoNombre}}]</span>
            </ng-template>
          </ng-select>
        </div>
      </div>
    </div>

    <div class="row">

      <div class="col-4">
        <div class="mb-4">
          <select class="form-select" disabled>
            <option *ngIf="!servicioSeleccionado" value="">ORIGEN</option>
            <option *ngIf="servicioSeleccionado" value="">{{servicioSeleccionado.sucursalOrigenNombre}}</option>
          </select>
        </div>
      </div>

      <div class="col-4">
        <div class="mb-4">
          <select class="form-select" disabled>
            <option *ngIf="!servicioSeleccionado" value="">DESTINO</option>
            <option *ngIf="servicioSeleccionado" value="">{{servicioSeleccionado.sucursalDestinoNombre}}</option>
          </select>
        </div>
      </div>

      <div class="col-4">
        <div class="mb-4">
          <select class="form-select" disabled>
            <option *ngIf="!servicioSeleccionado" value="">SENTIDO</option>
            <option *ngIf="servicioSeleccionado" value="">{{servicioSeleccionado.sentido}}</option>
          </select>
        </div>
      </div>

    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="mb-4">
          <h6>FECHA SALIDA TERMINAL</h6>
          <input type="text" class="form-control" bsDatepicker [(ngModel)]="fechas['fechaSalidaTerminalViajeComercial']"
                 [minDate]="hoy"
                 [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}">
        </div>
      </div>

      <div class="col-sm">
        <h6>HORA SALIDA TERMINAL</h6>
        <div class="hora mb-4">
          <div class="grInput">

            <button class="btn" (click)="decrementTime('horaSalidaTerminalViajeComercial')">
              <img src="assets/img/icoMenos.svg">
            </button>

            <input type="text" class="form-control" [(ngModel)]="horas['horaSalidaTerminalViajeComercial']"
              (input)="formatearTiempo($event, 'horaSalidaTerminalViajeComercial')"
              (blur)="normalizarCampoHora('horaSalidaTerminalViajeComercial')">

            <button class="btn" (click)="incrementTime('horaSalidaTerminalViajeComercial')">
              <img src="assets/img/icoMas.svg">
            </button>

          </div>
        </div>
      </div>

      <!--
      <div class="col-sm-auto">
        <h6>HABILITAR</h6>
        <div class="form-check form-switch mt-2 mb-4">
          <input class="form-check-input" type="checkbox" role="switch">
        </div>
      </div>
      -->
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="mb-4">
          <h6>FECHA INICIO VIAJE</h6>
          <input type="text" class="form-control" bsDatepicker [(ngModel)]="fechas['fechaInicioViajeComercial']"
                 (ngModelChange)="ajustarFechaTermino($event, 'fechaTerminoViajeComercial')"
                 [minDate]="hoy"
                 [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}">
        </div>
      </div>

      <div class="col-sm">
        <h6>HORA INICIO VIAJE</h6>
        <div class="hora mb-4">
          <div class="grInput">

            <button class="btn" (click)="decrementTime('horaInicioViajeComercial')">
              <img src="assets/img/icoMenos.svg">
            </button>

            <input type="text" class="form-control" [(ngModel)]="horas['horaInicioViajeComercial']"
              (input)="formatearTiempo($event, 'horaInicioViajeComercial')" 
              (blur)="normalizarCampoHora('horaInicioViajeComercial')">

            <button class="btn" (click)="incrementTime('horaInicioViajeComercial')">
              <img src="assets/img/icoMas.svg">
            </button>

          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="mb-4">
          <h6>FECHA TÉRMINO VIAJE</h6>
          <input type="text" class="form-control" bsDatepicker [(ngModel)]="fechas['fechaTerminoViajeComercial']"
                 [minDate]="fechas['fechaInicioViajeComercial']"
                 [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}">
        </div>
      </div>

      <div class="col-sm">
        <h6>HORA TERMINO VIAJE</h6>
        <div class="hora mb-4">
          <div class="grInput">

            <button class="btn" (click)="decrementTime('horaTerminoViajeComercial')">
              <img src="assets/img/icoMenos.svg">
            </button>

            <input type="text" class="form-control" [(ngModel)]="horas['horaTerminoViajeComercial']"
              (input)="formatearTiempo($event, 'horaTerminoViajeComercial')"
              (blur)="normalizarCampoHora('horaTerminoViajeComercial')">

            <button class="btn" (click)="incrementTime('horaTerminoViajeComercial')">
              <img src="assets/img/icoMas.svg">
            </button>

          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="mb-4">
          <h6>FECHA LLEGADA TERMINAL</h6>
          <input type="text" class="form-control" bsDatepicker [(ngModel)]="fechas['fechaLlegadaTerminalViajeComercial']"
                 [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}">
        </div>
      </div>

      <div class="col-sm">
        <h6>HORA LLEGADA TERMINAL</h6>
        <div class="hora mb-4">
          <div class="grInput">

            <button class="btn" (click)="decrementTime('horaLlegadaTerminalViajeComercial')">
              <img src="assets/img/icoMenos.svg">
            </button>

            <input type="text" class="form-control" [(ngModel)]="horas['horaLlegadaTerminalViajeComercial']"
              (input)="formatearTiempo($event, 'horaLlegadaTerminalViajeComercial')"
              (blur)="normalizarCampoHora('horaLlegadaTerminalViajeComercial')">

            <button class="btn" (click)="incrementTime('horaLlegadaTerminalViajeComercial')">
              <img src="assets/img/icoMas.svg">
            </button>

          </div>
        </div>
      </div>

      <!--
      <div class="col-sm-auto">
        <h6>HABILITAR</h6>
        <div class="form-check form-switch mt-2 mb-4">
          <input class="form-check-input" type="checkbox" role="switch">
        </div>
      </div>
      -->
    </div>

    <!--
    <div class="col-md-6">
      <div class="mb-4">

        <div class="paraderos">
          <ng-container>
            <div class="itemP inicio active">
              <div class="nombre">
                <p *ngIf="!servicioSeleccionado">Origen</p>
                <p *ngIf="servicioSeleccionado">{{ servicioSeleccionado.sucursalOrigenNombre }}</p>
              </div>
              <div class="date">
                <div class="fecha"></div>
              </div>
            </div>

            <div class="itemP final">
              <div class="nombre">
                <p *ngIf="!servicioSeleccionado">Destino</p>
                <p *ngIf="servicioSeleccionado">{{ servicioSeleccionado.sucursalDestinoNombre }}</p>
                <span>(Duración:)</span>
              </div>
              <div class="date">
                <div class="fecha"></div>
              </div>
            </div>

          </ng-container>
        </div>

      </div>
    </div>
    -->

    <div class="pb-4">
      <button *ngIf="!enviando && tienePermisoCrearViajeComercial()" class="btn btnOrange d-block mx-auto" (click)="crearViajeComercial()">CREAR SERVICIO COMERCIAL</button>
      <button *ngIf="enviando" class="btn btnOrange d-block mx-auto">CREANDO ...</button>
    </div>

  </div>
</div>


<!-- VIAJE NO COMERCIAL -->
<div class="boxWhite md" [ngClass]="{'d-none': !isTripTypeSelected(tripTypes.NO_COMERCIAL)}">

  <h4>CREAR SERVICIO NO COMERCIAL</h4>

  <button class="btn btnClose" (click)="cerrarModal()">
    <img src="assets/img/icoClose.svg">
  </button>

  <div class="contModal">
    <div class="row">
      <div class="col-md-6">
        <div class="mb-4">
          <select class="form-select" [(ngModel)]="selectedTripType" (change)="onTripTypeChange(selectedTripType)">
            <option *ngIf="tienePermisoCrearViajeComercial()" [value]="tripTypes.COMERCIAL">SERVICIO COMERCIAL</option>
            <option *ngIf="tienePermisoCrearViajeNoComercial()" [value]="tripTypes.NO_COMERCIAL">SERVICIO NO COMERCIAL</option>
            <option *ngIf="tienePermisoCrearViajeEspecial()" [value]="tripTypes.ESPECIAL">SERVICIO ESPECIAL</option>
          </select>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="mb-4">
          <input type="text" class="form-control" placeholder="Nombre del viaje" [(ngModel)]="nombreViajeNoComercial">
        </div>
      </div>
    </div>

    <div class="row">

      <div class="col-md-6">
        <div class="mb-4">
          <input type="text" class="form-control" placeholder="Lugar de origen" [(ngModel)]="textoParaderoOrigen">
        </div>
      </div>

      <div class="col-md-6">
        <div class="mb-4">
          <ng-select placeholder="TERMINAL ORIGEN" [multiple]="false" [items]="listaSucursales" bindLabel="nombre"
            [(ngModel)]="terminalOrigenSeleccionado">
            <ng-template ng-label-tmp let-item="item">
              <span>{{ item.nombre }}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
              <span>{{ item.nombre }}</span>
            </ng-template>
          </ng-select>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="mb-4">
          <h6>FECHA INICIO VIAJE</h6>
          <input type="text" class="form-control" bsDatepicker [(ngModel)]="fechas['fechaInicioViajeNoComercial']"
                 (ngModelChange)="ajustarFechaTermino($event, 'fechaTerminoViajeNoComercial')"
                 [minDate]="hoy"
                 [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}">
        </div>
      </div>

      <div class="col-sm">
        <h6>HORA INICIO VIAJE</h6>
        <div class="hora mb-4">
          <div class="grInput">

            <button class="btn" (click)="decrementTime('horaInicioViajeNoComercial')">
              <img src="assets/img/icoMenos.svg">
            </button>

            <input type="text" class="form-control" [(ngModel)]="horas['horaInicioViajeNoComercial']"
              (input)="formatearTiempo($event, 'horaInicioViajeNoComercial')"
              (blur)="normalizarCampoHora('horaInicioViajeNoComercial')">

            <button class="btn" (click)="incrementTime('horaInicioViajeNoComercial')">
              <img src="assets/img/icoMas.svg">
            </button>

          </div>
        </div>
      </div>
    </div>

    <div class="row">

      <div class="col-md-6">
        <div class="mb-4">
          <input type="text" class="form-control" placeholder="Lugar de destino" [(ngModel)]="textoParaderoDestino">
        </div>
      </div>

      <div class="col-md-6">
        <div class="mb-4">
          <ng-select placeholder="TERMINAL DESTINO" [multiple]="false" [items]="listaSucursales" bindLabel="nombre"
            [(ngModel)]="terminalDestinoSeleccionado">
            <ng-template ng-label-tmp let-item="item">
              <span>{{ item.nombre }}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
              <span>{{ item.nombre }}</span>
            </ng-template>
          </ng-select>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="mb-4">
          <h6>FECHA TERMINO VIAJE</h6>
          <input type="text" class="form-control" bsDatepicker [(ngModel)]="fechas['fechaTerminoViajeNoComercial']"
                 [minDate]="fechas['fechaInicioViajeNoComercial']"
                 [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}">
        </div>
      </div>

      <div class="col-sm">
        <h6>HORA TERMINO VIAJE</h6>
        <div class="hora mb-4">
          <div class="grInput">

            <button class="btn" (click)="decrementTime('horaTerminoViajeNoComercial')">
              <img src="assets/img/icoMenos.svg">
            </button>

            <input type="text" class="form-control" [(ngModel)]="horas['horaTerminoViajeNoComercial']"
              (input)="formatearTiempo($event, 'horaTerminoViajeNoComercial')"
              (blur)="normalizarCampoHora('horaTerminoViajeNoComercial')">

            <button class="btn" (click)="incrementTime('horaTerminoViajeNoComercial')">
              <img src="assets/img/icoMas.svg">
            </button>

          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="mb-4">
          <textarea rows="4" class="form-control" [(ngModel)]="descripcionViajeNoComercial"></textarea>
        </div>
      </div>
    </div>

    <div class="pb-4">
      <button *ngIf="!enviando && tienePermisoCrearViajeNoComercial()" class="btn btnOrange d-block mx-auto" (click)="crearViajeNoComercial()">CREAR SERVICIO NO COMERCIAL</button>
      <button *ngIf="enviando" class="btn btnOrange d-block mx-auto">CREANDO ...</button>
    </div>

  </div>
</div>


<!-- VIAJE ESPECIAL -->
<div class="boxWhite md" [ngClass]="{'d-none': !isTripTypeSelected(tripTypes.ESPECIAL)}">

  <h4>NUEVO SERVICIO ESPECIAL</h4>

  <button class="btn btnClose" (click)="cerrarModal()">
    <img src="assets/img/icoClose.svg">
  </button>

  <div class="contModal">
    <div class="row">
      <div class="col-md-6">
        <div class="mb-4">
          <select class="form-select" [(ngModel)]="selectedTripType" (change)="onTripTypeChange(selectedTripType)">
            <option *ngIf="tienePermisoCrearViajeComercial()" [value]="tripTypes.COMERCIAL">SERVICIO COMERCIAL</option>
            <option *ngIf="tienePermisoCrearViajeNoComercial()" [value]="tripTypes.NO_COMERCIAL">SERVICIO NO COMERCIAL</option>
            <option *ngIf="tienePermisoCrearViajeEspecial()" [value]="tripTypes.ESPECIAL">SERVICIO ESPECIAL</option>
          </select>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="mb-4">
          <ng-select placeholder="BUSCAR VIAJE..." [multiple]="false" [items]="listaViajes" bindLabel="nombre"
            [(ngModel)]="viajeEspecialSeleccionado" (ngModelChange)="actualizarCamposDesdeViaje($event)">
            <ng-template ng-label-tmp let-item="item">
              <span>{{ item.nombre }} [{{item.textoLibreOrigen}}, {{item.textoLibreDestino}}]</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
              <span>{{ item.nombre }} [{{item.textoLibreOrigen}}, {{item.textoLibreDestino}}]</span>
            </ng-template>
          </ng-select>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="mb-4">
          <input type="text" class="form-control" placeholder="Nombre del viaje" [(ngModel)]="nombreViajeEspecial">
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="mb-4">
          <input type="text" class="form-control" placeholder="Lugar de origen" [(ngModel)]="textoParaderoOrigen">
        </div>
      </div>

      <div class="col-md-6">
        <div class="mb-4">
          <ng-select placeholder="TERMINAL ORIGEN" [multiple]="false" [items]="listaSucursales" bindLabel="nombre"
            [(ngModel)]="terminalOrigenSeleccionado">
            <ng-template ng-label-tmp let-item="item">
              <span>{{ item.nombre }}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
              <span>{{ item.nombre }}</span>
            </ng-template>
          </ng-select>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="mb-4">
          <h6>FECHA INICIO VIAJE</h6>
          <input type="text" class="form-control" bsDatepicker [(ngModel)]="fechas['fechaInicioViajeEspecial']"
                 (ngModelChange)="ajustarFechaTermino($event, 'fechaTerminoViajeEspecial')"
                 [minDate]="hoy"
                 [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}">
        </div>
      </div>

      <div class="col-sm">
        <h6>HORA INICIO VIAJE</h6>
        <div class="hora mb-4">
          <div class="grInput">

            <button class="btn" (click)="decrementTime('horaInicioViajeEspecial')">
              <img src="assets/img/icoMenos.svg">
            </button>

            <input type="text" class="form-control" [(ngModel)]="horas['horaInicioViajeEspecial']"
              (input)="formatearTiempo($event, 'horaInicioViajeEspecial')"
              (blur)="normalizarCampoHora('horaInicioViajeEspecial')">

            <button class="btn" (click)="incrementTime('horaInicioViajeEspecial')">
              <img src="assets/img/icoMas.svg">
            </button>

          </div>
        </div>
      </div>
    </div>

    <hr>

    <div class="row">

      <div class="col-md-6">
        <div class="mb-4">
          <input type="text" class="form-control" placeholder="Lugar de destino" [(ngModel)]="textoParaderoDestino">
        </div>
      </div>

      <div class="col-md-6">
        <div class="mb-4">
          <ng-select placeholder="TERMINAL DESTINO" [multiple]="false" [items]="listaSucursales" bindLabel="nombre"
            [(ngModel)]="terminalDestinoSeleccionado">
            <ng-template ng-label-tmp let-item="item">
              <span>{{ item.nombre }}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
              <span>{{ item.nombre }}</span>
            </ng-template>
          </ng-select>
        </div>
      </div>


    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="mb-4">
          <h6>FECHA TERMINO VIAJE</h6>
          <input type="text" class="form-control" bsDatepicker [(ngModel)]="fechas['fechaTerminoViajeEspecial']"
                 [minDate]="fechas['fechaInicioViajeEspecial']"
                 [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}">
        </div>
      </div>

      <div class="col-sm">
        <h6>HORA TERMINO VIAJE</h6>
        <div class="hora mb-4">
          <div class="grInput">

            <button class="btn" (click)="decrementTime('horaTerminoViajeEspecial')">
              <img src="assets/img/icoMenos.svg">
            </button>

            <input type="text" class="form-control" [(ngModel)]="horas['horaTerminoViajeEspecial']"
              (input)="formatearTiempo($event, 'horaTerminoViajeEspecial')"
              (blur)="normalizarCampoHora('horaTerminoViajeEspecial')">

            <button class="btn" (click)="incrementTime('horaTerminoViajeEspecial')">
              <img src="assets/img/icoMas.svg">
            </button>

          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="mb-4">
          <textarea rows="4" class="form-control" [(ngModel)]="descripcion"></textarea>
        </div>
      </div>
    </div>

    <div class="pb-4">
      <button *ngIf="!enviando && tienePermisoCrearViajeEspecial()" class="btn btnOrange d-block mx-auto" [disabled]="enviando" (click)="crearViajeEspecial()">CREAR SERVICIO ESPECIAL</button>
      <button *ngIf="enviando" class="btn btnOrange d-block mx-auto">CREANDO ...</button>
    </div>

  </div>
</div>